import { Box, Typography, useTheme } from "@material-ui/core";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { formatFieldValue, getColumnClassName } from "../../../components/flexible/FieldWrapper";
import useStyles from "../../../containers/data/forms/forms-styles";
import { EMPTY_VALUE_PLACEHOLDER } from "../../../models/common/data";
import { AttributeSize, CatalogueAttribute, Maybe } from "../../../models/generated/graphql";
import { isEmptyValue } from "../../../utils/is-empty-value";

interface IProps {
	attribute: CatalogueAttribute;
	value: Maybe<string | number>;
}

export function PatientFieldWrapper(props: IProps) {
	const styles = useStyles();
	const { palette } = useTheme();
	const { t } = useTranslation();
	const formattedValue = formatFieldValue(props.value, props.attribute.dataType, null, t);

	return (
		<Box className={getColumnClassName(AttributeSize.Medium, styles)} pr={5}>
			<Fragment>
				<Typography noWrap variant="subtitle2" style={{ color: palette.enabledHeader.main }}>
					{t(props.attribute.shortLabelLocalizationKey)}
				</Typography>
				<Typography>{isEmptyValue(formattedValue) ? EMPTY_VALUE_PLACEHOLDER : formattedValue}</Typography>
			</Fragment>{" "}
		</Box>
	);
}
